import React from 'react';

import { Icon, Link, Text } from 'shell/components';

const LinkDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>Link</Text>
            <Link to={'#'}>Link</Link>
            <Link variant={'neutral'} to={'#'}>
                Neutral Link
            </Link>
            <Link disabled to={'#'}>
                Disabled Link
            </Link>

            <Link startIcon={<Icon kind={'add'} />} to={'#'}>
                Link
            </Link>
            <Link startIcon={<Icon kind={'add'} />} variant={'neutral'} to={'#'}>
                Neutral Link
            </Link>
            <Link disabled startIcon={<Icon kind={'add'} />} to={'#'}>
                Disabled Link
            </Link>

            <Link endIcon={<Icon kind={'add'} />} to={'#'}>
                Link
            </Link>
            <Link endIcon={<Icon kind={'add'} />} variant={'neutral'} to={'#'}>
                Neutral Link
            </Link>
            <Link disabled endIcon={<Icon kind={'add'} />} to={'#'}>
                Disabled Link
            </Link>
        </>
    );
};

export default LinkDemo;
